import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66dd64e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "container" }

import {userStorageModule} from '@/store/user-storage';
import BaseHeader from "@/components/base/base-header.vue";
import SubscriptionEditor from "@/components/employee/subscription-editor.vue";
import CustomerPriceEditor from "@/components/employee/customer-price-editor.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(BaseHeader, {
        "title-left": "Willkommen",
        "title-right": "Mitarbeiter",
        "title-main": "Mitarbeiter Dashboard"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SubscriptionEditor),
      _createVNode(CustomerPriceEditor)
    ])
  ]))
}
}

})